<template>
    <div class="liebiao">
        <!-- <div class="liebiaoTop">{{title.parent}}<span>></span>{{title.child}}</div> -->
        <div class="listTxt" v-for="(item, index) in detailList" @click="gotoArticle(item.id)">
            <span class="text">{{item.title}}</span>
            <span class="time">{{item.utime && item.utime.split(' ')[0]}}</span>
        </div>
        <div v-if="!detailList.length ? true : false" style="padding-top: 20px; font-size: 14px; text-align: center;">暂无数据</div>
        <div class="page">
            <span>共{{pages.total}}条，共{{pages.page_num}}/{{pages.page_total}}页</span>

            <a href="javascript:;" :class="{ disabled: pages.page_num === 1 }" @click="goPage('prev')"><</a>

            <a href="javascript:;" :class="{ current: pages.page_num === 1 }" @click="goPage('click', 1)">1</a>
            <a href="javascript:;" v-if="pages.page_num > 5" @click="fastPrev">...</a>
            <a href="javascript:;" v-if="pages.page_num === 5" @click="goPage('click', pages.page_num - 3)">{{ pages.page_num - 3 }}</a>
            <a href="javascript:;" v-if="pages.page_num - 2 > 1" @click="goPage('click', pages.page_num - 2)">{{ pages.page_num - 2 }}</a>
            <a href="javascript:;" v-if="pages.page_num - 1 > 1" @click="goPage('click', pages.page_num - 1)">{{ pages.page_num - 1 }}</a>
            <a href="javascript:;" v-if="pages.page_num != 1 && pages.page_num != pages.page_total" class="current">{{ pages.page_num }}</a>
            <a href="javascript:;" v-if="pages.page_num + 1 < pages.page_total" @click="goPage('click', pages.page_num + 1)">{{ pages.page_num + 1 }}</a>
            <a href="javascript:;" v-if="pages.page_num + 2 < pages.page_total" @click="goPage('click', pages.page_num + 2)">{{ pages.page_num + 2 }}</a>
            <a href="javascript:;" v-if="pages.page_total - pages.page_num === 4" @click="goPage('click', pages.page_num + 3)">{{ pages.page_num + 3 }}</a>
            <a href="javascript:;" v-if="pages.page_total - pages.page_num >= 5" @click="fastNext">...</a>
            <a href="javascript:;" :class="{ current: pages.page_total === pages.page_num }" v-if="pages.page_total > 1" @click="goPage('click', pages.page_total)">{{ pages.page_total }}</a>

            <a href="javascript:;" :class="{ disabled: pages.page_num === pages.page_total }" @click="goPage('next')">></a>

            <!-- <span>跳转</span> -->
            <input type="text" v-model="goPageNum">
            <a href="javascript:;" style="padding: 0 5px;" @click="goPage('input')">跳转</a>
        </div>
    </div>
</template>
<script>
export default {
    props: ['title', 'columnId'],
    data() {
        return {
            pages: {
                page_num: 1,
                page_size: 8,
                page_total: 1,
                total: 0
            },
            detailLists: '',
            detailList: '',
            goPageNum: '',
            actives: [[],[]]
        }
    },
    watch: {
        columnId: {
            handler(val) {
                this.pages.page_num = 1;
                this.getArticleByColumnId();
            },
            immediate: true
        },
        'pages.page_num'(val) {
            this.getArticleByColumnId();
        }
    },
    methods: {
        goPage(type, page_num) {
            let pages = this.pages;

            if (type === 'prev') {
                if (pages.page_num - 1 > 0) {
                    pages.page_num -= 1;
                }
            } else if (type === 'next') {
                if (pages.page_num + 1 <= pages.page_total) {
                    pages.page_num += 1;
                }
            } else if (type === 'input') {
                if (this.goPageNum <= pages.page_total && this.goPageNum >= 1) {
                    pages.page_num = this.goPageNum * 1;
                }
            } else if (type === 'click' && pages.page_num != page_num) {
                if (page_num <= pages.page_total) {
                    pages.page_num = page_num;
                }
            }
        },
        setPage() {
            this.pages.page_total = Math.max(1, Math.ceil(this.pages.total / this.pages.page_size));
        },
        fastPrev() {
            const page = this.pages.page_num - 5;
            if (page > 0) {
                this.pages.page_num = page;
            } else {
                this.pages.page_num = 1;
            }
        },
        fastNext() {
            const page = this.pages.page_num + 5;
            if (page > this.allPages) {
                this.pages.page_num = this.pages.page_total;
            } else {
                this.pages.page_num = page;
            }
        },
        async getArticleByColumnId() {

            let res = await this.$api.base.getArticleByColumnId({
                column_id: this.columnId,
                page_num: this.pages.page_num,
                page_size: this.pages.page_size,
                area: '',
                industry: '',
                title: ''
            })

            if (res.repBody.length) {
                res.repBody.forEach(value => {
                    value.date = (new Date(value.utime)).getTime();
                })
                res.repBody.sort(function(a, b){
                    return a.date < b.date;
                })
                this.detailLists = res.repBody;
                this.detailList = res.repBody.concat();
                this.pages.total = res.repBody[0].total;
                this.setPage();
            } else {
                this.detailList = [];
                this.pages.total = 0;
                this.setPage();
            }
        },
        gotoArticle(articleId) {
            this.$emit('change', articleId);
        }
    }
}
</script>
<style lang="scss" scoped>
.search {
    padding: 10px 0;
}
.search > div {
    padding-top: 10px;
}
.search input,.search .searchBtn {
    font-size: 12px;
    border-radius: 5px;
    line-height: 25px;
    vertical-align: middle;
}
.search input {
    width: 250px;
    height: 23px;
    padding-left: 5px;
    border: 1px solid #d6d6d6;
    outline: none;
}
.search input:focus {
    border: 1px solid #66afe9;
    -webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6); 
    box-shadow: inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6);
}
.search .searchBtn {
    display: inline-block;
    *display: inline;
    *zoom: 1;
    width: 60px;
    height: 25px;
    line-height: 26px;
    margin-left: 8px;
    text-align: center;
    color: white;
    background: #27a9e3;
}
.search .searchBtn:hover {
    background: #198bbe;
}
.search .item {
    position: relative;
    padding-left: 60px;
    line-height: 30px;
    border-bottom: 1px dashed #d6d6d6;
}
.search .item.hidden {
    height: 34px;
    overflow: hidden;
}
.search .item span {
    position: absolute;
    top: 10px;
    left: 0;
    font-size: 12px;
    color: #666;
}
.search .item .caret {
    position: absolute;
    top: 15px;
    right: 5px;
    width: 20px;
    height: 20px;
}
.search .item .caret:after {
    content: '';
    position: absolute;
    top: 3px;
    right: 6px;
    width: 8px;
    height: 8px;
    border: solid #787878;
    border-width: 0 1px 1px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    -o-transform: rotate(45deg);
    transform: rotate(45deg);
}
.search .item .caret.up:after {
    top: 6px;
    border-width: 1px 0 0 1px;
}
.search ul {
    position: relative;
    font-size: 0;
}
.search ul.down:after {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 10px;
    height: 10px;
}
.search li {
    display: inline-block;
    *display: inline;
    *zoom: 1;
    font-size: 12px;
    margin: 0 10px;
    color: #333;
    cursor: pointer;
}
.search li.active, .search li:hover {
    color: #27a9e3;
}

.page {
    padding-top: 30px;
    text-align: right;
    font-size: 0;
    line-height: 25px;
    span, a, input {
        display: inline-block;
        height: 30px;
        line-height: 30px;
        margin-left: 5px;
        text-align: center;
        font-size: 12px;
        color: #666;
        white-space: nowrap;
    }
    a {
        min-width: 30px;
        border: 1px solid #8ed6fa;
        border-radius: 5px;
        &.current {
            color: white;
            border-color: red;
            background: red;
            &:hover {
                border-color: red;
                cursor: not-allowed;
            }
        }
        &:hover {
            border-color: #65c8fa;
        }
        &.disabled {
            color: #999;
            cursor: not-allowed;
        }
    }
    input {
        width: 30px;
        border: 1px solid #d6d6d6;
        border-radius: 5px;
        outline: none;
        &:focus {
            border: 1px solid #66afe9;
            -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 8px rgba(102, 175, 233, .6);
            box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 8px rgba(102, 175, 233, .6);
        }
    }
}

.listTxt {

    display: flex;
    justify-content: space-between;
    padding: 15px 0;
    font-size: 14px;
    border-bottom: 1px dashed #d8d8d8;
    cursor: pointer;
    &:hover {
        .text {
            color: #eb1111;
            background: url(../images/index_icon_active.png) left center no-repeat;
            transform: translateX(1px);
        }
    }
    .text {
        padding-left: 15px;
        color: #666;
        background: url(../images/index_icon.png) left center no-repeat;
        transition: all .4s linear;
    }
    .time {
        color: #999;
    }
}
</style>